var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headBox"},[_c('div',{staticClass:"back",on:{"click":function($event){$event.stopPropagation();return _vm.backAction.apply(null, arguments)}}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"export"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }